import React, { Component } from "react";
import { getProperty } from "../../../CommonFunctions";
import { isMobileApp } from "../../../actions/Util";
import Pagination from "../../2/Controls/Pagination";
import CustomTable from "../../2/Controls/CustomTable";
import Icon from "../../2/Controls/Icon";

class ProductSalesTransaction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            rowsPerPage: 25,
            showFilterOptions: false,
            filterOptions: [],
            filteredSelectedValue: "All",
            filterSelectedTransactionId: "",
            tableData: [],
            loading: false,
            error: false,
            from: 0,
            size: 25,
            totalTransactionCount: 0,
        };

        this.newField = {
            TransactionType: "All",
            key: "",
        };
    }

    componentDidMount() {
        const salesTransactionType =
            this.props.config.TransactionTypes.filter(
                (e) =>
                    e.Module === "sales" &&
                    !e.IsDeleted
            );

        if (
            salesTransactionType &&
            salesTransactionType.length > 0
        ) {
            this.setState(
                {
                    filterOptions: [
                        this.newField,
                        ...salesTransactionType,
                    ],
                    filteredSelectedValue:
                        this.newField
                            .TransactionType,
                    filterSelectedTransactionId:
                        this.newField.key,
                },
                () => {
                    this.fetchData(
                        getProperty(
                            this.props.productData,
                            "key"
                        ),
                        this.state
                            .filterSelectedTransactionId
                    );
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const currentProductKey = getProperty(
            this.props.productData,
            "key"
        );

        const prevProductKey = getProperty(
            prevProps.productData,
            "key"
        );

        if (
            prevState.filterSelectedTransactionId !==
                this.state
                    .filterSelectedTransactionId ||
            prevState.from !==
                this.state.from ||
            prevState.size !==
                this.state.size ||
            prevProductKey !== currentProductKey
        ) {
            this.fetchData(
                currentProductKey,
                this.state
                    .filterSelectedTransactionId
            );
        }
    }

    fetchData = async (
        productId,
        transactionId
    ) => {
        const { from, size } = this.state;

        this.setState({
            loading: true,
        });

        try {
            const data =
                await this.props.getProductIdSalesTransaction(
                    from,
                    size,
                    productId,
                    transactionId,
                    ""
                );

          
            this.setState({
                loading: false,
                tableData:
                    getProperty(data, "sales") ||
                    [],
                totalTransactionCount:
                    getProperty(
                        data,
                        "totalCount"
                    ) || 0,
                error: false,
            });
        } catch (error) {
            console.error(
                "Error fetching data:",
                error
            );

            alert("Error Fetching Data!");

            this.setState({
                loading: false,
                tableData: [],
                error: true,
            });
        }
    };

    handleFilterOption = (option) => {
        this.setState({
            filteredSelectedValue:
                getProperty(
                    option,
                    "TransactionType"
                ),
            filterSelectedTransactionId:
                getProperty(option, "key"),
            showFilterOptions: false,
        });

        console.log(
            "Transaction Type:",
            getProperty(
                option,
                "TransactionType"
            ),
            "Transaction ID:",
            getProperty(option, "key")
        );
    };

    handlePageChange = (newPage) => {
        this.setState((prevState) => ({
            currentPage: newPage,
            from:
                (newPage - 1) *
                prevState.rowsPerPage,
        }));
    };

    handleRowsPerPageChange = (newSize) => {
        this.setState({
            rowsPerPage: newSize,
            size: newSize,
            currentPage: 1,
            from: 0,
        });
    };

    render() {
        const {
            currentPage,
            rowsPerPage,
            showFilterOptions,
            filterOptions,
            filteredSelectedValue,
            tableData,
            loading,
            totalTransactionCount,
        } = this.state;

        const columns = [
            {
                field: "TransactionNo",
                headerName: "Transaction No",
            },
            {
                field: "TransactionDate",
                headerName:
                    "Transaction Date",
                type: "date",
            },

            ...(filteredSelectedValue ===
            "All"
                ? [
                      {
                          field:
                              "TransactionType",
                          headerName:
                              "Transaction Type",
                      },
                  ]
                : []),

            {
                field: "StoreName",
                headerName: "Store Name",
            },

            {
                field: "MRP",
                headerName: "MRP",
                type: "currency",
            },

            {
                field: "RetailPrice",
                headerName:
                    "Retail Price",
                type: "currency",
            },

            {
                field: "Qty",
                headerName: "Qty",
                type: "number",
            },

            {
                field: "Brand",
                headerName: "Unit",
                type: "number",
            },

            {
                field: "SubTotal",
                headerName: "Subtotal",
                type: "currency",
            },

            {
                field: "DiscountAmount",
                headerName: "Discount",
                type: "number",
            },

            {
                field: "TaxGroup",
                headerName: "Tax",
            },

            {
                field: "TotalTax",
                headerName:
                    "Tax Amount",
                type: "currency",
            },

            {
                field: "Amount",
                headerName: "Total",
                type: "currency",
            },
        ];

        return (
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    paddingTop: "16px",
                }}
            >
                <div
                    style={{
                        flexGrow: 1,
                        overflow: "hidden",
                        paddingBottom:
                            isMobileApp()
                                ? "48px"
                                : "50px",
                    }}
                >
                    <div
                        style={{
                            paddingLeft: "16px",
                            paddingRight:
                                "16px",
                            paddingTop: "12px",
                            marginBottom:
                                "8px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                            }}
                        >
                            <div
                                style={{
                                    position:
                                        "relative",
                                }}
                            >
                                <span
                                    style={{
                                        display:
                                            "block",
                                    }}
                                >
                                    <button
                                        onClick={() =>
                                            this.setState(
                                                {
                                                    showFilterOptions:
                                                        !showFilterOptions,
                                                }
                                            )
                                        }
                                        style={{
                                            display:
                                                "flex",
                                            alignItems:
                                                "center",
                                            background:
                                                "#F5F5F5",
                                            height:
                                                "34px",
                                            padding:
                                                "0 8px",
                                            border:
                                                "1px solid #ddd",
                                            borderRadius:
                                                "8px",
                                            cursor:
                                                "pointer",
                                            color:
                                                "#5e5e5e",
                                            width:
                                                "auto",
                                        }}
                                    >
                                        Filtered By :
                                        <span
                                            style={{
                                                color:
                                                    "#000000",
                                                marginLeft:
                                                    "4px",
                                            }}
                                        >
                                            {
                                                filteredSelectedValue
                                            }
                                        </span>

                                        <span
                                            style={{
                                                width:
                                                    "10px",
                                                display:
                                                    "inline-flex",
                                                marginBottom:
                                                    "2px",
                                                marginLeft:
                                                    "4px",
                                            }}
                                        >
                                            <Icon type="downarrownew" />
                                        </span>
                                    </button>

                                    {showFilterOptions && (
                                        <div
                                            style={{
                                                position:
                                                    "absolute",
                                                zIndex: 10,
                                                marginTop:
                                                    "6px",
                                                borderRadius:
                                                    "8px",
                                                background:
                                                    "#ffffff",
                                                width:
                                                    "100%",
                                                top: "100%",
                                                left: 0,
                                                boxShadow:
                                                    "0 2px 10px rgba(215, 213, 226, 0.5), 0 4px 6px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            {filterOptions.map(
                                                (
                                                    option,
                                                    index
                                                ) => (
                                                    <div
                                                        key={
                                                            index
                                                        }
                                                        onClick={() =>
                                                            this.handleFilterOption(
                                                                option
                                                            )
                                                        }
                                                        style={{
                                                            padding:
                                                                "8px",
                                                            cursor:
                                                                "pointer",
                                                        }}
                                                    >
                                                        {getProperty(
                                                            option,
                                                            "TransactionType"
                                                        )}
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>

                    <CustomTable
                        columns={columns}
                        loading={loading}
                        rows={tableData}
                        showTextOnRows={
                            tableData.length >
                            0
                                ? null
                                : "No data available"
                        }
                        allowMobilePagination={
                            true
                        }
                        pagination={{
                            currentPage,
                            totalCount:
                                totalTransactionCount,
                            rowsPerPage,
                            onPageChange:
                                this
                                    .handlePageChange,
                            loading,
                        }}
                    />
                </div>

                {!isMobileApp() && (
                 
                        <Pagination
                            count={
                                totalTransactionCount
                            }
                            page={currentPage}
                            rowsPerPage={
                                rowsPerPage
                            }
                            onPageChange={
                                this
                                    .handlePageChange
                            }
                            onRowsPerPageChange={
                                this
                                    .handleRowsPerPageChange
                            }
                        />
                
                )}
            </div>
        );
    }
}

export default ProductSalesTransaction;